
































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { BtnList } from '@/types/common/btn'
import { rateList, newPersionList, savePension } from '@/api/newPersion'
import { riskTypeFind } from '@/api/portfolio'
import { CommonMudule } from '@/store/modules/common'

import BaseInfo from '@/views/newPension/components/baseInfo/index.vue'
import FormItem from '@/components/formItem/index.vue'
import NewFooter from '@/views/newPension/components/newFooter'
import { NewPersionMap, RateListMap } from '@/types/newPersion'
@Component({
  components: { BaseInfo, FormItem, NewFooter },
})
export default class DemandTargetPage extends Vue {
  @Prop() route!: string;
  @Prop() idx!: number;

  rateList: RateListMap[] = [];

  defaultAgeRangeObj = {
    retireAge: 0,
    deathAge: 0,
    rangeList: [1, 100],
    defalutValue: [60, 84],
  };

  defaultCurrentMonthAmountObj = {
    rangeList: [0, 100000],
    marks: {
      10000: '1万元/月',
      50000: '5万元/月',
      80000: '8万元/月',
    },
  };

  defaultAssumeInflationRateObj = {
    rangeList: [0.1, 8],
    marks: {
      // 1.7: '默认通货膨胀率',
    },
  };

  form: NewPersionMap = {
    // retireAge: '', // 退休年龄
    // deathAge: '', // 养老年金领取至
    // totalIncome10k: '', // 家庭年收入（万元）
  };

  handleInp (value: number, type: string) {
    const { rangeList } = this.defaultAgeRangeObj
    if (value >= rangeList[0] && value <= rangeList[1]) {
      this.form[type] = value
    } else {
      let _value = 0
      if (type === 'deathAge') {
        _value = rangeList[1]
      } else {
        _value = rangeList[0]
      }
      this.form[type] = this.defaultAgeRangeObj[type] = _value
    }

    // this.form.deathAge = values[1]
  }

  handleSlider (values: number[]) {
    this.form.retireAge = this.defaultAgeRangeObj.retireAge = values[0]
    this.form.deathAge = this.defaultAgeRangeObj.deathAge = values[1]
  }

  private setFormatTooltip (value: number) {
    const flag = this.defaultAgeRangeObj.retireAge === value
    let _value = ''
    if (flag) {
      _value = '开始领取: ' + value + '岁'
    } else {
      _value = '结束领取: ' + value + '岁'
    }
    return _value
  }

  private setFormatTooltip1 (value: string) {
    return value + '元/月'
  }

  private setFormatTooltip2 (value: string) {
    return value + '%'
  }

  private async nextPage (item: BtnList) {
    if (item.btnType === 'ok') {
      await savePension({
        ...this.form,
        assumeInflationRate: (this.form.assumeInflationRate || 0) / 100,
        customerId: CommonMudule.customerId,
      })
    }
    this.$emit('on-edit-btn', item.btnType, this.idx)
  }

  async created () {
    const customerIdObj = { customerId: CommonMudule.customerId }
    const res2 = await riskTypeFind(customerIdObj)
    if (res2.data) {
      this.defaultAgeRangeObj.rangeList[0] = res2.data.age + 1
    }
    const res = await newPersionList(customerIdObj)
    if (res?.data) {
      const _res = cloneDeep(res.data)
      if (!_res.retireAge) {
        _res.retireAge = this.defaultAgeRangeObj.defalutValue[0]
      }
      if (!_res.deathAge) {
        _res.deathAge = this.defaultAgeRangeObj.defalutValue[1]
      }
      // this.defaultAgeRangeObj.value = [_res.retireAge, _res.deathAge]
      this.defaultAgeRangeObj.retireAge = _res.retireAge
      this.defaultAgeRangeObj.deathAge = _res.deathAge
      this.form = _res
      this.form.retireAge = _res.retireAge
      this.form.assumeInflationRate = _res.assumeInflationRate ? +(_res.assumeInflationRate * 100).toFixed(2) : 0
      const res1 = await rateList()
      if (res1.data) {
        const _rateList: RateListMap[] = []
        res1.data.forEach((item: RateListMap) => {
          if (item.name !== '默认通胀率') {
            _rateList.push(item)
          } else {
            if (!res.data.assumeInflationRate) {
              this.form.assumeInflationRate = +(+item.value * 100).toFixed(2)
            }
            this.defaultAssumeInflationRateObj.marks = {
              [+(+item.value * 100).toFixed(2)]: '默认通货膨胀率'
            }
          }
        })
        this.rateList = _rateList
      }
    }
  }
}
